//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('timeRegisterMenu', {
//        templateUrl: 'views/components/views/trMenu/trMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'trMenuService', 'trNewJobService', function ($stateParams, stateService, trMenuService, trNewJobService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let labourNo = $stateParams.labour_no;

//            vm.model = {
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await trNewJobService.getTrMenu({ labour_no: labourNo }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'custactCalcPickSelect':
//                        trMenuService.getPickSelectSettings({
//                            p2_pofinish_keyno: vm.model.menu.p2_pofinish_keyno,
//                            custact_no: vm.model.menu.custactcalc_custact_no
//                        }).then(function (response) {
//                            state = response[0].webpagename;

//                            go(response[0].parms);
//                        });
//                        break;
//                    case 'trNewJob':
//                        if (vm.model.menu.custactcalc_custact_no > 0) {
//                            state = 'custactcalcjobexit';

//                            go({
//                                labour_no: vm.model.menu.labour_no,
//                                custactcalc_custact_no: vm.model.menu.custactcalc_custact_no,
//                                function_name: 'SWITCH'
//                            });
//                        } else {
//                            state = 'trnewjob';

//                            go({ labour_no: vm.model.menu.labour_no });
//                        }
//                        break;
//                    case 'trNewJobConf':
//                        if (vm.model.menu.custactcalc_custact_no > 0) {
//                            state = 'custactcalcjobexit';

//                            go({
//                                labour_no: vm.model.menu.labour_no,
//                                custactcalc_custact_no: vm.model.menu.custactcalc_custact_no,
//                                function_name: 'EXIT'
//                            });
//                        } else {
//                            state = 'trnewjobconf';

//                            go({
//                                labour_no: vm.model.menu.labour_no,
//                                argtype: 'exit',
//                                argvalue: '0'
//                            });
//                        }
//                        break;
//                    case 'trstart':
//                        go();
//                        break;
//                    case 'pofinishprodlist':
//                        go({ p2_pofinish_keyno: vm.model.menu.p2_pofinish_keyno });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
